<template>
  <div v-if="!loading">
    <div class="card px-3">
      <div class="card-header">
        <h4 class="card-title">User: {{ user.full_name }}</h4>
        <div class="pb-4 pt-2">
          <div class="card-text spaced-rows border-bottom-rows">
            <div class="row">
              <div class="col-3 font-weight-bold">User Id</div>
              <div class="col-9">{{ user.id }}</div>
            </div>
            <div class="row">
              <div class="col-3 font-weight-bold">First Name</div>
              <div class="col-9">{{ user.first_name }}</div>
            </div>
            <div class="row">
              <div class="col-3 font-weight-bold">Last Name</div>
              <div class="col-9">{{ user.last_name }}</div>
            </div>
            <div class="row">
              <div class="col-3 font-weight-bold">Email</div>
              <div class="col-9">{{ user.email }}</div>
            </div>
          </div>
          <div class="btn btn-primary" @click="signInAsUser('enroll_talent')">
            Sign in (Enroll Talent)
          </div>
          <div class="btn btn-primary ml-2" @click="signInAsUser('ats')">
            Sign in (ATS legacy)
          </div>
        </div>
      </div>
    </div>
    <UserAdminActions
      :user="user"
      api-base="users"
      @updated="fetchUser"
    />
    <div class="card px-3" v-if="user.teams.length">
      <div class="card-header">
        <h4 class="card-title">User's teams</h4>
      </div>
      <div class="pb-3">
        <b-tabs pills card @input="handleTeamTabChanged">
          <b-tab
            :title="`${team.name} (${team.id})`"
            v-for="team in user.teams"
            :key="team.id"
          >
            <div class="card-text py-3">
              <div class="spaced-rows border-bottom-rows">
                <div class="row">
                  <div class="col-3 font-weight-bold">Team Id</div>
                  <div class="col-9">{{ team.id }}</div>
                </div>
                <div class="row">
                  <div class="col-3 font-weight-bold">Team Name</div>
                  <div class="col-9">{{ team.name }}</div>
                </div>
                <div class="row">
                  <div class="col-3 font-weight-bold">Team Slug</div>
                  <div class="col-9">{{ team.slug }}</div>
                </div>
                <div class="row">
                  <div class="col-3 font-weight-bold">Team Owner</div>
                  <div class="col-9">
                    <div>
                      {{ `${team.owner.full_name} (${team.owner.id})` }}
                    </div>
                    <div class="text-muted">{{ team.owner.email }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 font-weight-bold">Agency</div>
                  <div class="col-9">{{ team.is_agency ? "Yes" : "No" }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">
                  <router-link
                    :to="{ name: 'team', params: { teamId: team.id } }"
                    class="btn btn-primary mt-4"
                  >
                    View Team
                  </router-link>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-3 font-weight-bold">
                  Permissions
                </div>
                <div class="col-9">
                  <b-form-group>
                    <b-form-checkbox-group
                      stacked
                      v-model="permissionSelected"
                      id="user-team-permissions"
                      :options="permissionOptions"
                      name="user-team-permissions"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">
                  <div
                    class="btn btn-primary mt-4"
                    @click="updateTeamPermission(team.id)"
                  >
                    Update user's team permissions
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { BTabs, BTab, BFormGroup, BFormCheckboxGroup } from "bootstrap-vue";
import UserAdminActions from "@/components/Admin/UserAdminActions.vue";
export default {
  components: {
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckboxGroup,
    UserAdminActions
  },
  props: {
    userId: {
      required: true,
      type: [String, Number]
    }
  },
  data() {
    return {
      user: {},
      loading: false,
      isPosting: false,
      permissionOptions: [
        "manage_users",
        "manage_companies",
        "manage_offers",
        "manage_candidates",
        "manage_subscriptions",
        "manage_credit_cards"
      ],
      permissionSelected: []
    };
  },
  async created() {
    await this.fetchUser();
  },
  methods: {
    async fetchUser() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/enroll_admin/users/${this.userId}`
        );
        this.user = data;
      } finally {
        this.loading = false;
      }
    },
    async updateTeamPermission(teamId) {
      this.isPosting = true;
      const payload = {
        team_id: teamId,
        permissions: this.permissionSelected
      };
      await this.$http
        .put(`/enroll_admin/users/${this.userId}/permissions`, payload)
        .then(() => {
          Vue.$toast.success("Permission updated");
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data;
            Object.keys(errors).forEach(key => {
              const message = errors[key].join("<br>");
              Vue.$toast.error(message);
            });
          }
        })
        .finally(() => {
          this.isPosting = false;
        });
    },
    handleTeamTabChanged(tabIndex) {
      const team = this.user.teams[tabIndex];
      if (team) {
        this.permissionSelected = team.user_permissions.map(
          user_permission => user_permission.name
        );
      }
    },
    signInAsUser(client = "enroll_talent") {
      this.$http
        .post("/enroll_admin/ats/sign-in-as-user-secure-link", {
          email: this.user.email,
          client
        })
        .then(({ data }) => {
          window.open(data.url);
        })
        .catch(error => {
          // Sans ce catch, un 422 (client inconnu, ou HOST_* non configuré sur
          // ce serveur — cf. SignInAsUserSecureLinkController) ne produisait
          // rien du tout à l'écran : le bouton semblait simplement inerte.
          const message =
            error.response && error.response.status === 422
              ? Object.values(error.response.data)
                  .flat()
                  .join("<br>")
              : "Could not generate the sign-in link";
          Vue.$toast.error(message);
        });
    }
  }
};
</script>
